export default __webpack_public_path__ + "static/whatsapp-8bb3f3b9b8079502ab65bc53d204c5b1.png";